import { Injectable } from '@angular/core';
import { ApolloService } from './apollo.service';
import { from } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MonitoringService {

  constructor(private apolloService: ApolloService) { }



  getLogs(filter: any) {
    const query = `
            query getLog($filter: LogFilterInput!) {
            getLog(filter: $filter) {
              data {
                timestamp
                message
              }
              message
              success
              statusCode
            }
        }
        `;
    return from(this.apolloService.query(query).refetch({ filter: filter }));
  }


}
